import { FC } from 'react';

import { Loader } from 'lucide-react';
import { cn } from '@/lib/utils';

interface IProps {
  noBackground?: boolean;
}

const SimpleSpinner: FC<IProps> = ({ noBackground }) => {
  return (
    <div
      className={cn('absolute inset-0 z-50 flex items-center justify-center', {
        'bg-[rgba(255,255,255,.6)]': !noBackground,
      })}
    >
      <div className='animate-spin'>
        <Loader />
      </div>
    </div>
  );
};

export default SimpleSpinner;
